// extracted by mini-css-extract-plugin
export var clickableWrapper = "_21-2";
export var placeholderIcon = "_21-3";
export var thumbnailCanvas = "_21-1";
export var thumbnailWrapper = "_21-0";